import { Link } from 'react-router-dom';

import styles from '@containers/ErrorPages/ErrorPages.module.css';

import Img404 from '@assets/svg/404_img.svg';

export const Page404 = () => (
  <div className={styles.errorWrapper}>
    <Img404 className={styles.manIcon} />
    <h3 className={styles.title}>404. Page Not Found</h3>
    <p className={styles.info}>
      Our apologies. We&rsquo;re unable to find the page you&rsquo;re looking
      for.
    </p>
    <div>
      <Link to="/" type="button" className={styles.homeBtn}>
        HOME PAGE
      </Link>
    </div>
  </div>
);
